import React, { useEffect } from 'react';
import { ChakraProvider, Box, Button, Text, useColorModeValue as mode } from '@chakra-ui/react';
import { signInUrl, storedReturnPath } from '../../utils/auth';

// /login?error=<code> from server/auth/saml (session.js loginErrorCode, identity.js resolveAccount), ?signedOut=1 after a sign-out
const MESSAGES = {
  signedOut: 'You are signed out.',
  account_inactive: 'Your user is deactivated in the admin. Ask an administrator to reactivate it.',
  account_ambiguous: 'More than one active user in the admin has your email address. Ask an administrator to fix the employee records.',
  account_conflict: 'Your email address belongs to a user that is linked to another Microsoft account. Ask an administrator.',
  missing_identity: 'Microsoft did not send your email address. Ask an administrator to check the single sign-on claims.',
  provisioning_failed: 'Your user could not be created automatically. Ask an administrator to add you.',
  invalid_response: 'The answer from Microsoft could not be verified. Try again; if it keeps happening, tell an administrator.',
  request_expired: 'The sign-in took too long or was already used. Please try again.',
  response_expired: 'The sign-in from Microsoft has expired. Check that the date and time of this device are correct and try again.',
  idp_error: 'Microsoft refused the sign-in. Check that your account has access to this app.',
  sso_unavailable: 'Microsoft sign-in is not configured on this server. Tell an administrator.',
  sign_in_failed: 'Signing in failed. Please try again.'
};

export default function Login() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');
  const message = params.get('signedOut') ? MESSAGES.signedOut : error ? MESSAGES[error] || MESSAGES.sign_in_failed : null;

  useEffect(() => {
    // a refused sign-in must not be retried silently by ProtectedRoute
    if (error) localStorage.removeItem('currentUser');
  }, [error]);

  return (
    <ChakraProvider>
      <div
        style={{
          backgroundColor: 'white',
          height: '100vh',
          backgroundImage: 'url(schuilenburg.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <Box style={{ paddingTop: '25vh' }} />
        <Box display="flex" flexDirection="column" alignItems="center" mt={20} mx={{ sm: 'auto' }} gap={4}>
          {message && (
            <Box bg="white" p="4" shadow="base" rounded={{ sm: 'lg' }} maxW="md" mx="4" data-testid="login-message">
              <Text color={error ? 'red.600' : 'gray.700'}>{message}</Text>
            </Box>
          )}
          <Box bg={mode('gray', 'gray.700')} p="4" shadow="base" rounded={{ sm: 'lg' }}>
            <Button colorScheme="whiteAlpha" variant="solid" onClick={() => window.location.assign(signInUrl(storedReturnPath()))}>
              LOGIN WITH MICROSOFT ACCOUNT
            </Button>
          </Box>
        </Box>
      </div>
    </ChakraProvider>
  );
}
